import React, { forwardRef, useState } from 'react';

// Six boxes for the login code. ONE real <input> lies invisibly over them, so
// typing, pasting, the phone's "from Messages" suggestion (one-time-code) and
// screen readers all behave exactly as with a plain field; the boxes only
// draw what is in it. `state` paints the row: 'error' shakes it (replayed on
// every new `shakeKey`), 'checking' runs a wave while the code is verified.
const CodeSlots = forwardRef(function CodeSlots(
    { value, onChange, disabled, state = 'idle', shakeKey = 0, id, describedBy },
    ref
) {
    const [focused, setFocused] = useState(false);
    const active = Math.min(value.length, 5);

    return (
        <div className="sl-code" dir="ltr">
            <div key={shakeKey} className={`sl-code-row${state === 'error' ? ' is-shake' : ''}`}>
                {Array.from({ length: 6 }, (_, i) => {
                    const ch = value[i] || '';
                    const isActive = focused && !disabled && i === active;
                    const cls = [
                        'sl-slot',
                        ch ? 'is-filled' : '',
                        isActive ? 'is-active' : '',
                        state === 'error' ? 'is-error' : '',
                        state === 'checking' ? 'is-checking' : ''
                    ].filter(Boolean).join(' ');
                    return (
                        <div
                            key={i}
                            className={cls}
                            style={state === 'checking' ? { animationDelay: `${i * 90}ms` } : undefined}
                        >
                            {ch ? <span key={ch + i} className="sl-digit">{ch}</span> : null}
                            {isActive && !ch && <span className="sl-caret" />}
                        </div>
                    );
                })}
            </div>
            {/* Transparent, not opacity:0 — iOS offers the code from Messages only to a field it sees. */}
            <input
                ref={ref}
                id={id}
                type="text"
                inputMode="numeric"
                autoComplete="one-time-code"
                pattern="[0-9]*"
                maxLength={6}
                value={value}
                onChange={onChange}
                onFocus={() => setFocused(true)}
                onBlur={() => setFocused(false)}
                disabled={disabled}
                aria-invalid={state === 'error'}
                aria-describedby={describedBy}
                className="sl-code-input"
                autoFocus
            />
        </div>
    );
});

export default CodeSlots;
